import styled from 'styled-components';

export const StyledAdnotationText = styled.div`
    margin-top: -20px;
    margin-left: 14px;
`;
